import { render } from "./PlayerMediaWorkspace.vue?vue&type=template&id=78739c81&scoped=true"
import script from "./PlayerMediaWorkspace.vue?vue&type=script&lang=js"
export * from "./PlayerMediaWorkspace.vue?vue&type=script&lang=js"

import "./PlayerMediaWorkspace.vue?vue&type=style&index=0&id=78739c81&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78739c81"]])

export default __exports__